import { Link } from 'react-router-dom';
import type { ProductPipelineMigrate } from '../../content/productShared';

type ProductMigrateProps = ProductPipelineMigrate & {
  tone: 'dark' | 'light';
};

export function ProductMigrate({ kicker, title, body, ctaLabel, ctaTo, tone }: ProductMigrateProps) {
  return (
    <section className={`migrate band-${tone}`}>
      <div className="container">
        <div className="migrate-card reveal">
          <div className="migrate-copy">
            <div className="kicker">{kicker}</div>
            <h2>{title}</h2>
            <p>{body}</p>
          </div>
          <div className="act">
            <Link to={ctaTo} className="btn btn-primary">
              {ctaLabel} <span className="arrow">→</span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
